import VLPChart from "./VLPChart";

export const ChartsSection = () => {
	return <VLPChart />;
}